import { ResponseMiddleware } from "@/shared/utils/http-client";

export const forbiddenMiddleware = (onForbidden: () => void): ResponseMiddleware => {
    return async (ctx, next) => {
        const result = await next(ctx);

        if (ctx.response?.status === 403) onForbidden();

        return result
    }
}